// mapHelpers.js
/**
 * Fonctions utilitaires pour la gestion des routes et positions sur la carte.
 * Totalement indépendantes de Vue.
 */

// --- Promesse utile pour attendre un délai ---
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

// --- Courbes / easing ---
export const easeInOutQuad = t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)

// --- Poids du tracé en fonction du zoom ---
export const getStrokeWeightForZoom = zoom => Math.max(3, zoom * 0.4)

// --- Gestion des points ---
export function removeDuplicatePoints(points) {
  if (!points?.length) return []
  return points.filter(
    (p, i) =>
      i === 0 || p.lat !== points[i - 1].lat || p.lng !== points[i - 1].lng,
  )
}

export function removeClosePoints(points, epsilon = 0.0001) {
  if (!points?.length) return []
  const filtered = [points[0]]
  for (let i = 1; i < points.length; i++) {
    const prev = filtered[filtered.length - 1]
    const curr = points[i]
    if (Math.abs(prev.lat - curr.lat) + Math.abs(prev.lng - curr.lng) > epsilon)
      filtered.push(curr)
  }
  return filtered
}

export function interpolatePoints(start, end, segments = 10) {
  return Array.from({ length: segments }, (_, i) => ({
    lat: start.lat + ((end.lat - start.lat) * (i + 1)) / segments,
    lng: start.lng + ((end.lng - start.lng) * (i + 1)) / segments,
  }))
}

export function smoothRoute(points, density = 10) {
  if (!points?.length) return []
  const smooth = []
  for (let i = 0; i < points.length - 1; i++) {
    smooth.push(points[i])
    smooth.push(...interpolatePoints(points[i], points[i + 1], density))
  }
  smooth.push(points[points.length - 1])
  return smooth
}

// --- Conversion et offset ---
export function latLngToPoint(map, latLng) {
  if (!map) return { x: 0, y: 0 }
  const proj = map.getProjection()
  if (!proj) return { x: 0, y: 0 }
  const point = proj.fromLatLngToPoint(latLng)
  const scale = Math.pow(2, map.getZoom())
  return { x: point.x * scale, y: point.y * scale }
}

export function offsetCenter(latLng, offsetY, map) {
  if (!map) return latLng
  const proj = map.getProjection()
  if (!proj) return latLng
  const scale = Math.pow(2, map.getZoom())
  const worldCoordinateCenter = proj.fromLatLngToPoint(latLng)
  const pixelOffset = new google.maps.Point(0, offsetY / scale)
  const worldCoordinateNewCenter = new google.maps.Point(
    worldCoordinateCenter.x,
    worldCoordinateCenter.y + pixelOffset.y,
  )
  return proj.fromPointToLatLng(worldCoordinateNewCenter)
}

export function fitBoundsWithOffset(map, bounds, offsetY) {
  if (!map || !bounds) return
  map.fitBounds(bounds)
  if (!offsetY) return
  map.panTo(offsetCenter(bounds.getCenter(), offsetY, map))
}
